var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClippathgroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2992_886)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2992_886",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 59,
    height: 59
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59 0H0V59H59V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2992_886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.2334 44.25C48.1334 44.25 49.6084 40.9312 49.6084 36.875V22.125C49.6084 18.0687 48.1334 14.75 42.2334 14.75C36.3334 14.75 34.8584 18.0687 34.8584 22.125V36.875C34.8584 40.9312 36.3334 44.25 42.2334 44.25Z",
    stroke: "#BC8639",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7666 44.25C10.8666 44.25 9.3916 40.9312 9.3916 36.875V22.125C9.3916 18.0687 10.8666 14.75 16.7666 14.75C22.6666 14.75 24.1416 18.0687 24.1416 22.125V36.875C24.1416 40.9312 22.6666 44.25 16.7666 44.25Z",
    stroke: "#BC8639",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1416 29.5H34.8598",
    stroke: "#BC8639",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3125 35.6452V23.3535",
    stroke: "#BC8639",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.6875 35.6452V23.3535",
    stroke: "#BC8639",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2992_886"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 59,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClippathgroup);
export default __webpack_public_path__ + "static/media/Clip path group.57f6dd4e5fc743c9ae7e227cd45c9768.svg";
export { ForwardRef as ReactComponent };